import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledModalTitle = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;

	${Text} {
		color: #ffffff;
		font-size: 18px;
		font-weight: 700;
	}
`;

export { StyledModalTitle };
